import { Button, Card, Col, DatePicker, Form, Input, InputNumber, Row, Select } from "antd";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";
import PageTitle from "../page-header/PageHeader";
import { createWorker } from "../../redux/actions/hr/workerActions";
import { getAllMachines } from "../../api/machineApi";

const AddWorker = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [salaryType, setSalaryType] = useState("monthly");
  const [machines, setMachines] = useState([]);

  useEffect(() => {
    getAllMachines({ query: "all", is_inhouse: true }).then((res) => {
      const list = Array.isArray(res) ? res : res?.getAllMachine || [];
      setMachines(list.filter((m) => m.is_active));
    }).catch(() => {});
  }, []);

  const onFinish = async (values) => {
    setLoading(true);
    const payload = {
      ...values,
      join_date: values.join_date ? values.join_date.toISOString() : null,
    };
    const resp = await dispatch(createWorker(payload));
    setLoading(false);
    if (resp.message === "success") navigate("/hr/workers");
  };

  return (
    <>
      <PageTitle title="Back" />
      <Card title="Add Worker">
        <Form form={form} layout="vertical" onFinish={onFinish} initialValues={{ salary_type: "monthly", shift_hours: 8, working_days: "mon-sat" }}>
          <Row gutter={16}>
            <Col xs={24} md={8}>
              <Form.Item name="name" label="Name" rules={[{ required: true }]}>
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item name="phone" label="Phone">
                <Input />
              </Form.Item>
            </Col>
            <Col xs={24} md={8}>
              <Form.Item name="id_no" label="ID No">
                <Input />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item name="department" label="Department">
                <Input placeholder="e.g. Corrugation, Printing" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="designation" label="Designation">
                <Input placeholder="e.g. Operator, Helper" />
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="worker_type" label="Worker Type">
                <Select allowClear placeholder="Select type">
                  <Select.Option value="skilled">Skilled</Select.Option>
                  <Select.Option value="unskilled">Unskilled</Select.Option>
                  <Select.Option value="supervisor">Supervisor</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            <Col xs={24} md={6}>
              <Form.Item name="join_date" label="Join Date">
                <DatePicker style={{ width: "100%" }} />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xs={24} md={6}>
              <Form.Item name="salary_type" label="Salary Type" rules={[{ required: true }]}>
                <Select onChange={(v) => { setSalaryType(v); if (v === "hourly") form.setFieldValue("working_days", undefined); }}>
                  <Select.Option value="monthly">Monthly</Select.Option>
                  <Select.Option value="hourly">Hourly</Select.Option>
                </Select>
              </Form.Item>
            </Col>
            {salaryType === "monthly" && (
              <Col xs={24} md={6}>
                <Form.Item name="monthly_salary" label="Monthly Salary (₹)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: "100%" }} min={0} />
                </Form.Item>
              </Col>
            )}
            {salaryType === "hourly" && (
              <Col xs={24} md={6}>
                <Form.Item name="hourly_rate" label="Hourly Rate (₹)" rules={[{ required: true }]}>
                  <InputNumber style={{ width: "100%" }} min={0} />
                </Form.Item>
              </Col>
            )}
            {salaryType === "monthly" && (
              <Col xs={24} md={6}>
                <Form.Item name="shift_hours" label="Shift Hours/Day">
                  <InputNumber style={{ width: "100%" }} min={1} max={24} />
                </Form.Item>
              </Col>
            )}
            {salaryType === "monthly" && (
              <Col xs={24} md={6}>
                <Form.Item name="working_days" label="Working Days">
                  <Select allowClear placeholder="Select">
                    <Select.Option value="mon-sat">Mon – Sat (6 days)</Select.Option>
                    <Select.Option value="mon-fri">Mon – Fri (5 days)</Select.Option>
                  </Select>
                </Form.Item>
              </Col>
            )}
          </Row>
          <Row gutter={16}>
            <Col xs={24}>
              <Form.Item name="machine_ids" label="Machines Can Operate">
                <Select
                  mode="multiple"
                  allowClear
                  placeholder="Select machines this worker can operate"
                  optionFilterProp="children"
                  showSearch
                >
                  {machines.map((m) => (
                    <Select.Option key={m.id} value={m.id}>{m.name} ({m.code})</Select.Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item name="address" label="Address">
            <Input.TextArea rows={2} />
          </Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>Save Worker</Button>
        </Form>
      </Card>
    </>
  );
};

export default AddWorker;
